import PriorityImage from "@core/helpers/client/components/priority-image";


const ImageComponent = ({
	media = undefined,
	src,
	placeholder_src,
	style,
	width,
	height,
	default_src_options = {},
	custom_default_svg,
	linear_gradient,
	image_className,
	placeholder_width,
	placeholder_height,
	className,
	alt,
	// true → "lcp", false → "lazy"; not passed → ImagePriorityProvider, then "lcp" (the old default)
	isLCP,
	priority_level,
	storage_prefix_url,
	fill,
	sizes,
	...props
}) => {

	const full_src = () => {
		const _src = media?.url || src || placeholder_src;
		if (!_src) return null;
		if (_src.startsWith("http") || _src.startsWith("/")) return _src;
		return `${storage_prefix_url}/${_src}`;
	};

	return (
		<>
			<div
				className={className || ""}
				style={{
					position: "relative",
					width: style?.width || `${width}px`,
					height: style?.height || `${height}px`,
					...style,
				}}
			>
				{/*<div*/}
				{/*	className="shimmer-animation"*/}
				{/*	style={{*/}
				{/*		position: "absolute",*/}
				{/*		inset: 0,*/}
				{/*		width: "100%",*/}
				{/*		height: "100%",*/}
				{/*		zIndex: 0,*/}
				{/*	}}*/}
				{/*/>*/}

				<PriorityImage
					isLCP={isLCP}
					priority_level={priority_level}
					// `position: inherit` used to come from an injected <style> tag that
					// was duplicated once per image on the page. Inline it instead —
					// except in fill mode, where next/image sets position itself and the
					// old class (being a class) could never have overridden it anyway.
					style={{ ...(fill ? {} : { position: "inherit" }), ...style }}
					src={full_src()}
					alt={media?.alt || alt || ""}
					className={`image-position ${image_className || ""} ${className || ""}`}
					width={fill ? undefined : width || media?.media?.information?.width || placeholder_width || 100}
					height={fill ? undefined : height || media?.media?.information?.height || placeholder_height || 100}
					// 75 (next/image's default, in the core config's `images.qualities`). It was 100: on jument's shop home
					// ~310 image URLs were q=100 and Lighthouse estimated ~380KB of savings. A caller that needs more still
					// passes `quality` (props below override it). The old `qualities={[100]}` is not a next/image prop; it
					// only leaked into the HTML as a `qualities="100"` attribute.
					quality={75}
					placeholder="empty"
					// "100vw" unless the image sits in a slider/grid that knows its column width (ImageSizesProvider)
					sizes={sizes}
					fallback_sizes="100vw"
					fill={fill}

					{...props}
				/>
			</div>
		</>
	);
};

export default ImageComponent;
